import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useTableControlsStyles = makeStyles(() =>
  createStyles({
    title: {
      minWidth: 200,
    },
    noMatches: {
      minWidth: 282,
    },
    buttonWrapper: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
    drawerBackdrop: {
      backgroundColor: 'transparent',
    },
  })
);

export default useTableControlsStyles;
